// theme-init.js
// Global, AI-friendly section initialization system for custom JS.
// Safely initializes sections on initial load and when Shopify
// dynamically loads/updates sections in the theme editor.

(function () {
  // Registry object: section_type -> init function (for future use)
  window.SectionInitializers = window.SectionInitializers || {};

window.SectionInitializers['custom-video-feature'] = function(container) {
  var $container = $(container);
  var $slider = $container.find('.video-product');

  // If no slider or only one slide, do nothing
  if (!$slider.length || $slider.children().length <= 1) {
    return;
  }

  if (typeof $.fn.slick !== 'function') {
    console.warn('Slick is not loaded for custom-video-feature section.');
    return;
  }

  // Avoid double init
  if ($slider.hasClass('slick-initialized')) {
    return;
  }

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    appendDots: $container.find('.slide-m-dots'),
    prevArrow: $container.find('.slide-m-prev'),
    nextArrow: $container.find('.slide-m-next'),
    adaptiveHeight: true
  });
};

  /**
   * Run any registered section initializers for elements with data-section-type.
   */
  function runSectionInitializers(root) {
    var context = root || document;
    var sectionNodes = context.querySelectorAll('[data-section-type]');

    sectionNodes.forEach(function (sectionEl) {
      var sectionType = sectionEl.getAttribute('data-section-type');
      if (!sectionType) return;

      var initFn = window.SectionInitializers[sectionType];
      if (typeof initFn !== 'function') return;

      // Avoid double-initializing sections
      if (sectionEl.__sectionInitialized) return;
      sectionEl.__sectionInitialized = true;

      try {
        initFn(sectionEl);
      } catch (err) {
        console.error('Error initializing section:', sectionType, err);
      }
    });
  }

  /**
   * Initialize all hero sliders (.hero-banner-slider) using Slick.
   * Works across the whole document or inside a given root (for section reloads).
   */
  function initHeroSliders(root) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
      return;
    }

    var context = root || document;
    var $ = window.jQuery;
    var $sliders = $(context).find('.hero-banner-slider');

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);
      if ($this.hasClass('slick-initialized')) return;

$this.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  // Use global selectors – matches how the section was originally built
  appendDots: window.jQuery('.slide-banner-dots'),
  prevArrow: window.jQuery('.slide-banner-prev'),
  nextArrow: window.jQuery('.slide-banner-next'),
  autoplay: false,
  arrows: true,
  dots: true,
  autoplaySpeed: 2000
});

    });
  }

  /**
   * Run all initialization for a given root.
   */
  function initAll(root) {
    runSectionInitializers(root);
    initHeroSliders(root);
  }

  // When sections are dynamically loaded/changed in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      initAll(event.target);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event && event.target) {
      initAll(event.target);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    if (event && event.target) {
      var section = event.target.closest('[data-section-type]');
      initAll(section || document);
    }
  });


/* --------------------------------------------------------------------------
 * Slick-based sections
 * These replace inline <script> initializers inside sections to keep JS centralized,
 * defer-friendly, and compatible with Shopify theme editor dynamic rendering.
 * -------------------------------------------------------------------------- */

function tbInitSlick($slider, options) {
  if (!$slider || !$slider.length) return;
  if (typeof window.jQuery === 'undefined' || typeof jQuery.fn.slick !== 'function') {
    console.warn('Slick/jQuery not available when initializing slider:', $slider);
    return;
  }
  // Avoid double-init
  if ($slider.hasClass('slick-initialized')) {
    try { $slider.slick('unslick'); } catch (e) {}
  }
  $slider.slick(options);
}

window.SectionInitializers['customer-review'] = function(container) {
  var $c = jQuery(container);
  var $slider = $c.find('.customer-review-wrapper');
  tbInitSlick($slider, {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dots: true,
    prevArrow: '<div class="prev-arrow gallery-arrows"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M27.25 17.5L20.75 24L27.25 30.5" stroke="#252525" stroke-width="2" stroke-linecap="round"/></svg></div>',
    nextArrow: '<div class="next-arrow gallery-arrows"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M20.75 17.5L27.25 24L20.75 30.5" stroke="#252525" stroke-width="2" stroke-linecap="round"/></svg></div>',
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 990,  settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 767,  settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true, adaptiveHeight: false } }
    ]
  });
};

window.SectionInitializers['product-reviews'] = function(container) {
  var $c = jQuery(container);
  var $slider = $c.find('.customer-review-wrapper');
  // Uses the same configuration as customer-review.
  window.SectionInitializers['customer-review'](container);
};

window.SectionInitializers['home-collection-box'] = function(container) {
  var $c = jQuery(container);
  var $slider = $c.find('.hero-collection-slider');

  // Responsive slidesToShow logic
  function computeSlidesToShow() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (w >= 1024) return 3;
    if (w >= 600) return 1.5;
    return 1.1;
  }

  tbInitSlick($slider, {
    infinite: false,
    speed: 800,
    centerMode: false,
    dots: true,
    appendDots: $c.find('.slide-collection-dots'),
    prevArrow: $c.find('.slide-collection-prev'),
    nextArrow: $c.find('.slide-collection-next'),
    slidesToShow: computeSlidesToShow(),
    slidesToScroll: 1
  });

  // Re-init on resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      tbInitSlick($slider, {
        infinite: false,
        speed: 800,
        centerMode: false,
        dots: true,
        appendDots: $c.find('.slide-collection-dots'),
        prevArrow: $c.find('.slide-collection-prev'),
        nextArrow: $c.find('.slide-collection-next'),
        slidesToShow: computeSlidesToShow(),
        slidesToScroll: 1
      });
    }, 150);
  });
};

window.SectionInitializers['custom-best-selling'] = function(container) {
  var $c = jQuery(container);
  var $slider = $c.find('.custom-feature-products-test');

  function computeSlidesToShow() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (w >= 1024) return 4;
    if (w >= 600) return 3;
    return 1.2;
  }

  tbInitSlick($slider, {
    infinite: false,
    speed: 800,
    centerMode: false,
    dots: true,
    appendDots: $c.find('.slide-selling-dots'),
    prevArrow: $c.find('.slide-selling-prev'),
    nextArrow: $c.find('.slide-selling-next'),
    slidesToShow: computeSlidesToShow(),
    slidesToScroll: 1
  });

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      tbInitSlick($slider, {
        infinite: false,
        speed: 800,
        centerMode: false,
        dots: true,
        appendDots: $c.find('.slide-selling-dots'),
        prevArrow: $c.find('.slide-selling-prev'),
        nextArrow: $c.find('.slide-selling-next'),
        slidesToShow: computeSlidesToShow(),
        slidesToScroll: 1
      });
    }, 150);
  });
};

window.SectionInitializers['product-frequently'] = function(container) {
  var $c = jQuery(container);
  var $slider = $c.find('.product-frequently');

  tbInitSlick($slider, {
    infinite: true,
    speed: 800,
    centerMode: true,
    prevArrow: '<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none"><path d="M6.5 1L1.5 6L6.5 11" stroke="#252525" stroke-width="2" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none"><path d="M1.5 1L6.5 6L1.5 11" stroke="#252525" stroke-width="2" stroke-linecap="round"/></svg></button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600,  settings: { slidesToShow: 1 } }
    ]
  });
};


  // Initial page load - called last so all SectionInitializers above are registered first.
  // Since this file is deferred, readyState is already 'interactive' when it runs,
  // so we call initAll directly rather than waiting for DOMContentLoaded.
  initAll(document);

})();
